import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { TenantProvider } from './lib/tenant';
import { SessionProvider } from './lib/session';
import { ErrorBoundary } from './components/ui';
import { App } from './App';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('The application root element is missing from index.html.');

createRoot(container).render(
  <StrictMode>
    {/*
      Tenant before session, deliberately: the sign-in page must already know
      whose sign-in page it is, and the session provider asks the tenant layer
      to load the full configuration once somebody signs in.
    */}
    {/*
      An outer boundary as well as the per-route one inside the shell. If the
      shell itself fails there is still something to read and somewhere to go,
      rather than a white page.
    */}
    <ErrorBoundary title="The application could not start">
      <TenantProvider>
        <SessionProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </SessionProvider>
      </TenantProvider>
    </ErrorBoundary>
  </StrictMode>,
);
